import RecordVoiceOverOutlinedIcon from "@mui/icons-material/RecordVoiceOverOutlined"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import Typography from "@mui/material/Typography"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"

import Column from "../../../common/components/Column"
import Row from "../../../common/components/Row"
import { useIsMobile } from "../../../common/utils"
import { closeConciergeGreetingRequiredDialog } from "../reducer"
import { SETTINGS_TABS, createSettingsTabURL } from "../settings"
import DialogHeader from "./DialogHeader"

export default function ConciergeGreetingRequiredDialog() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const isMobile = useIsMobile()
  const open = useSelector(
    (state) => state.customer.conciergeGreetingRequiredDialogOpen
  )

  function handleClose() {
    dispatch(closeConciergeGreetingRequiredDialog())
  }

  function handleGoToSettings() {
    handleClose()
    navigate(
      createSettingsTabURL(SETTINGS_TABS.phoneSms, { focus: "greeting" })
    )
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="xs"
      fullScreen={isMobile}
      keepMounted
    >
      <DialogHeader title="Greeting required" onClose={handleClose} />
      <DialogContent>
        <Column sx={{ gap: 3 }}>
          <Row sx={{ justifyContent: "center" }}>
            <RecordVoiceOverOutlinedIcon
              sx={{
                fontSize: "5em",
                fill: (theme) => theme.palette.warning.main,
              }}
            />
          </Row>
          <Column sx={{ gap: 2 }}>
            <Typography variant="h3" sx={{ textAlign: "center" }}>
              Add an inbound voicemail greeting
            </Typography>
            <Typography variant="body1" sx={{ fontSize: "0.9em" }}>
              Before calling candidates or leads, upload or record a custom
              greeting for this account. Callers who reach your Concierge number
              will hear this message when leaving voicemail.
            </Typography>
          </Column>
        </Column>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="primary" onClick={handleClose}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleGoToSettings}
        >
          Go to Settings
        </Button>
      </DialogActions>
    </Dialog>
  )
}
